import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunnerOptionalParameter,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { clearCart, ClearCartApiParameter } from "@insite/client-framework/Services/CartService";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import displayOrder from "@insite/client-framework/Store/Pages/OrderApprovalDetails/Handlers/DisplayOrder";
import { CartModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<HasOnSuccess, ClearCartApiParameter, CartModel>;

export const DispatchBeginDeleteOrder: HandlerType = props => {
    props.dispatch({
        type: "Pages/OrderApprovalDetails/BeginDeleteOrder",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    const state = props.getState();
    const { cartId } = state.pages.orderApprovalDetails;
    if (cartId) {
        props.apiParameter = {
            cartId,
        };
    }
};

export const SendDataToApi: HandlerType = async props => {
    try {
        await clearCart(props.apiParameter);
    } catch (error) {
        if ("status" in error && error.status === 403) {
            props.dispatch({ type: "Data/OrderApprovals/Reset" });
            props.dispatch(displayOrder({ cartId: props.getState().pages.orderApprovalDetails.cartId! }));
            return false;
        }
        throw error;
    }
};

export const LoadCart: HandlerType = props => {
    const state = props.getState();
    const currentCartId = state.data.carts.currentId;

    if (currentCartId !== props.apiParameter.cartId) {
        return;
    }

    props.dispatch(loadCurrentCart());
};

export const DispatchOrderApprovalsReset: HandlerType = props => {
    props.dispatch({
        type: "Data/OrderApprovals/Reset",
    });
};

export const DispatchCompleteDeleteOrder: HandlerType = props => {
    props.dispatch({
        type: "Pages/OrderApprovalDetails/CompleteDeleteOrder",
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [
    DispatchBeginDeleteOrder,
    PopulateApiParameter,
    SendDataToApi,
    LoadCart,
    DispatchOrderApprovalsReset,
    DispatchCompleteDeleteOrder,
    ExecuteOnSuccessCallback,
];

const deleteOrder = createHandlerChainRunnerOptionalParameter(chain, {}, "DeleteOrder");
export default deleteOrder;
